import { render, staticRenderFns } from "./CpttAdd.vue?vue&type=template&id=1e61d31c&scoped=true&"
import script from "./CpttAdd.vue?vue&type=script&lang=js&"
export * from "./CpttAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61d31c",
  null
  
)

export default component.exports